"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceByViewportWidth = void 0;
const __1 = require("../..");
/**
 * Calculates the device name based on the
 * ranges of viewport widths. This is used just as a fallback of get
 * the device name in the campaign URL parameters.
 *
 * @param {number} [minTablet=720] Limit between mobile and tablet.
 * @param {number} [maxTablet=1024] Limit between tablet and desktop.
 *
 * @returns {string} The device name.
 */
function getDeviceByViewportWidth(minTablet = 720, maxTablet = 1024) {
    const viewportWidth = window.screen.availWidth;
    let deviceFound = __1.DeviceName.Desktop;
    if (viewportWidth <= minTablet) {
        deviceFound = __1.DeviceName.Mobile;
    }
    else if (viewportWidth > minTablet && viewportWidth <= maxTablet) {
        deviceFound = __1.DeviceName.Tablet;
    }
    return deviceFound;
}
exports.getDeviceByViewportWidth = getDeviceByViewportWidth;
//# sourceMappingURL=get-device-by-viewport-width.js.map